(function() {
  var CESTAS = 4;

  var BASKET_COMPOSITIONS = {
    P: { total: 7,  items: [['Folhas:','1'],['Legumes:','2'],['Raiz:','2'],['Fruta:','1'],['Tempero:','1']] },
    M: { total: 9,  items: [['Folhas:','2'],['Legumes:','2'],['Raiz:','2'],['Fruta:','2'],['Tempero:','1']] },
    G: { total: 11, items: [['Folhas:','2/2'],['Legumes:','3/2'],['Raiz:','2/2'],['Fruta:','2/3'],['Tempero:','2/2']] }
  };

  var observer = null;

  function parseBRL(text) {
    return Math.round(
      parseFloat(text.trim().replace(/[^\d,]/g,'').replace(',','.')) * 100
    );
  }

  function formatBRL(cents) {
    return (cents / 100).toLocaleString('pt-BR', {
      style: 'currency', currency: 'BRL'
    });
  }

  function getCurrentSize(variantTitle) {
    var v;
    if (variantTitle) {
      v = variantTitle;
    } else {
      var input = document.querySelector('variant-picker input[name^="Tamanho"]:checked');
      if (!input) return 'M';
      v = input.value || '';
    }
    v = v.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    if (v === 'pequena') return 'P';
    if (v === 'media')   return 'M';
    if (v === 'grande')  return 'G';
    if (v === 'p')       return 'P';
    if (v === 'm')       return 'M';
    if (v === 'g')       return 'G';
    return 'M';
  }

  function renderCestaInfo(size) {
    var basket = BASKET_COMPOSITIONS[size];
    if (!basket) return '';
    var itemsStr = basket.items.map(function(it) {
      return `<div class="sjb-cesta-item"><strong>${it[0]}</strong> ${it[1]}</div>`;
    }).join('');
    return '<div class="sjb-cesta-info">' +
             '<div class="sjb-cesta-title">A Cesta ' + size + ' contém ' + basket.total + ' itens:</div>' +
             '<div class="sjb-cesta-items">' + itemsStr + '</div>' +
           '</div>';
  }

  function injectBreakdown(option, variantTitle) {
    option.querySelector('.sjb-breakdown')?.remove();

    var amountEl = option.querySelector('.appstle_subscription_amount');
    if (!amountEl) return;
    var compareEl = option.querySelector('.appstle_subscription_compare_amount');

    var price = parseBRL(amountEl.textContent);
    if (!price) return;

    var comparePrice = compareEl ? parseBRL(compareEl.textContent) : 0;
    var perCesta = Math.round(price / CESTAS);
    var isAvulsa = !option.classList.contains('appstle_include_dropdown');

    var riscado = (!isAvulsa && comparePrice > price)
      ? '<span class="sjb-compare">' + formatBRL(comparePrice) + '</span>'
      : '';

    var el = document.createElement('div');
    el.className = 'sjb-breakdown' + (isAvulsa ? ' sjb-avulsa' : ' sjb-assinatura');
    el.innerHTML =
      (isAvulsa ? '<div class="sjb-prova">Compra única — Prove por 30 dias antes de assinar.</div>' : '') +
      '<div class="sjb-row">' +
        '<span class="sjb-total">' + formatBRL(price) + '</span>' +
        '<span class="sjb-cestas">por mês</span>' +
        riscado +
      '</div>' +
      '<div class="sjb-unit">Valor por cesta: <br> <strong>' + formatBRL(perCesta) + '</strong></div>' +
      renderCestaInfo(getCurrentSize(variantTitle));

    var radioWrapper = option.querySelector('.appstle_subscription_radio_wrapper');
    if (radioWrapper && radioWrapper.parentNode) {
      radioWrapper.parentNode.insertBefore(el, radioWrapper.nextSibling);
    } else {
      option.appendChild(el);
    }
  }

  function run(variantTitle) {
    if (observer) observer.disconnect();
    document.querySelectorAll('.appstle_subscription_wrapper_option').forEach(function(opt) {
      injectBreakdown(opt, variantTitle);
    });
    var widget = document.querySelector('.appstle_sub_widget');
    if (widget) {
      observer = new MutationObserver(function(mutations) {
        var relevant = mutations.some(function(m) {
          return ![].slice.call(m.addedNodes).some(function(n) {
            return n.classList && n.classList.contains('sjb-breakdown');
          });
        });
        if (relevant) run();
      });
      observer.observe(widget, { childList: true, subtree: true });
    }
  }

  function waitAndRun() {
    var tries = 0;
    var interval = setInterval(function() {
      tries++;
      var options = document.querySelectorAll('.appstle_subscription_wrapper_option');
      var hasPrice = options.length > 0 && options[0].querySelector('.appstle_subscription_amount');
      if (hasPrice) {
        clearInterval(interval);
        run();
      }
      if (tries > 20) clearInterval(interval);
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitAndRun);
  } else {
    waitAndRun();
  }

  document.addEventListener('variant:update', function(e) {
    var resource = e && e.detail && e.detail.resource;
    var size = null;
    if (resource) {
      size = resource.option1 || (resource.options && resource.options[0]) || resource.title;
    }
    run(size);
  });
})();
